var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"right_menu",attrs:{"id":"right_menu"}},[_c('ul',[_c('li',{class:{
        'disabled': _vm.isdeleteDisabled
      },on:{"click":_vm.deleteClick}},[_vm._v("删除")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }